<div class="printer-container">
  <mat-form-field appearance="fill" color="black" class="printer-field" style="width: 90%;">
    <mat-label>{{"inputs.printer_selector" | translate}}</mat-label>
    <mat-select #printer (selectionChange)="setPrinter(printer.value)">
      <mat-option value="print-1">
        Print 1
      </mat-option>
      <mat-option value="print-2">
        Print 2
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div class="content">
  <div class="card">
    <div class="card-content">
      <div class="card-body">
        <button
          *ngIf="!isList"
          routerLink="/orders-reportages"
          title="{{ 'inputs.back' | translate }}"
          mat-icon-button
        >
          <mat-icon>keyboard_backspace</mat-icon>
          {{ "inputs.back" | translate }}
        </button>

        <h1 *ngIf="isList">{{ "titles.list.product_ordered" | translate }}</h1>
        <h1 *ngIf="!isList">{{ "titles.edit.product_ordered" | translate }}</h1>

        <div *ngIf="!isList && !isNew">
          <div *ngFor="let photo of product_ordered_photo">
            <p style="float: left">
              <a [href]="photo.imageUrl" target="_blank"
                ><img [src]="photo.imageUrl"
              /></a>
            </p>
            <div style="float: left">
              <h1>{{ reportage_name }}</h1>
              <p>
                {{ "inputs.creation_date" | translate }}:
                {{ creation_date | date: "d/M/Y, H:mm:ss" }} <br />
                {{ "inputs.modification_date" | translate }}:
                {{ modification_date | date: "d/M/Y, H:mm:ss" }}
              </p>
              <p>
                {{ "tables.reference" | translate }}: {{ orders.reference }}
                <br />
                {{ "inputs.address" | translate }}: {{ orders.address }} <br />
                {{ "inputs.name" | translate }}: {{ orders.name }}
                {{ orders.surname }}<br />
                {{ "inputs.identifier_type" | translate }}: {{ orders.dni }} <br />
                {{ "inputs.phone" | translate }}: {{ orders.phone }} <br />
                {{ "inputs.subtotal" | translate }}:
                {{ orders.value.toFixed(2) }} €<br />
                {{ "inputs.value_shipping" | translate }}:
                {{ orders.value_shipping.toFixed(2) }} €<br />
              </p>
            </div>

            <h2 style="text-align: right">
              <div>
                <button
                  mat-raised-button
                  matTooltip="Imprimir etiqueta envío"
                  (click)="printLabel('shipping')"
                >
                  <span> {{ "inputs.printShippingLabel" | translate }} </span>
                </button>
                <br />
                <button mat-raised-button (click)="processAllProducts()">
                  <span> {{ "inputs.process_all" | translate }} </span>
                </button>
                <button
                  mat-raised-button
                  (click)="goTo(next_unprocessed)"
                  style="{{ disable_next_unprocessed | translate }}"
                >
                  <!-- <span> {{'inputs.process_all' | translate}} </span> -->
                  <span>{{ "inputs.next_unprocessed" | translate }}</span>
                </button>
              </div>
              {{ "inputs.status" | translate }}:
              {{ "status." + status | translate }}
            </h2>
          </div>
        </div>
        <div *ngIf="isList" class="clear-filters-button-wrapper">
          <button
            mat-mini-fab
            type="button"
            (click)="clearFilters()"
            [ngClass]="
              disableClearFilterButton
                ? 'disabled-clear-filters-button'
                : 'clear-filters-button'
            "
            [disabled]="disableClearFilterButton"
          >
            <mat-icon>replay</mat-icon>
          </button>
        </div>
        <div style="clear: left"></div>

        <div class="media-body">
          <mat-form-field *ngIf="isList">
            <mat-label>{{ "inputs.search" | translate }}</mat-label>
            <input
              matInput
              (keydown.enter)="applyFilter($event)"
              id="input"
              placeholder="{{ 'inputs.search' | translate }}"
              #input
            />
          </mat-form-field>
          <div *ngIf="isList" id="divFilter" [formGroup]="filterForm">
            <label>{{ "inputs.filter" | translate }}: </label>
            <mat-form-field appearance="legacy">
              <mat-label>{{ "titles.list.reportages" | translate }}</mat-label>
              <mat-select
                matNativeControl
                [formControlName]="'reportages'"
                (selectionChange)="applyFilter($event.value)"
              >
                <mat-option
                  *ngFor="let reportage of reportages"
                  [value]="reportage.id"
                >
                  {{ reportage.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- <mat-form-field appearance="legacy">
                <mat-label>{{ 'inputs.lines' | translate }}</mat-label>
                <mat-select matNativeControl [formControlName]="'lines'">
                  <mat-option *ngFor="let line of lines" [value]="line.id">
                    {{line.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field> -->
            <mat-form-field appearance="legacy">
              <mat-label>{{ 'inputs.yearperiods' | translate }}</mat-label>
              <mat-select matNativeControl [formControlName]="'yearPeriod'" (selectionChange)="applyFilter($event.value)">
                <mat-option [value]="">{{ 'inputs.any' | translate }}</mat-option>
                <mat-option *ngFor="let period of yearperiods" [value]="period.id">
                  {{period.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            
            <mat-checkbox
              [formControlName]="'unprocessed_only'"
              [color]="'primary'"
              (change)="applyFilter($event.value)"
              >{{ "inputs.unprocessed_only" | translate }}
            </mat-checkbox>
          </div>

          <div *ngIf="isList">
            <!-- && dataSource -->
            <table mat-table [dataSource]="dataSource" matSort>
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ "tables.name" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="goTo(element.suborder)"
                >
                  {{ element.photo_reportage_name }}
                </td>
              </ng-container>
              <!-- Second Column -->
              <ng-container matColumnDef="reference">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ "tables.reference" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="goTo(element.suborder)"
                >
                  {{ element.reference }}
                </td>
              </ng-container>
              <ng-container matColumnDef="reportage">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ "tables.reportage" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="goTo(element.suborder)"
                >
                  {{ element.reportage_name }}
                </td>
              </ng-container>

              <ng-container matColumnDef="product_es">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  fxHide.lt-sm
                  style="display: {{ 'es' | translate }}"
                >
                  {{ "tables.product_name" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="goTo(element.suborder)"
                  fxHide.lt-sm
                  style="display: {{ 'es' | translate }}"
                >
                  {{ element.product_name_es }}
                </td>
              </ng-container>
              <ng-container matColumnDef="product_en">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  fxHide.lt-sm
                  style="display: {{ 'en' | translate }}"
                >
                  {{ "tables.product_name" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="goTo(element.suborder)"
                  fxHide.lt-sm
                  style="display: {{ 'en' | translate }}"
                >
                  {{ element.product_name_en }}
                </td>
              </ng-container>
              <ng-container matColumnDef="product_cat">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  fxHide.lt-sm
                  style="display: {{ 'cat' | translate }}"
                >
                  {{ "tables.product_name" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="goTo(element.suborder)"
                  fxHide.lt-sm
                  style="display: {{ 'cat' | translate }}"
                >
                  {{ element.product_name_cat }}
                </td>
              </ng-container>
              <ng-container matColumnDef="quantity">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  fxHide.lt-sm
                >
                  {{ "tables.quantity" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="goTo(element.suborder)"
                  fxHide.lt-sm
                >
                  {{ element.quantity }}
                </td>
              </ng-container>
              <!-- <ng-container matColumnDef="album_id">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  fxHide.lt-sm
                >
                  Album ID
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="goTo(element.suborder)"
                  fxHide.lt-sm
                >
                  {{ element.album_id ? element.album_id : "None" }}
                </td>
              </ng-container> -->
              <!-- <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm> {{ 'tables.status' | translate }} </th>
                  <td mat-cell *matCellDef="let element" (click)="goTo(element.reference)" fxHide.lt-sm> {{element.status }} </td>
                </ng-container> -->
              <!-- Action Column -->
              <ng-container matColumnDef="actions" class="actionsColumn">
                <th mat-header-cell *matHeaderCellDef>
                  {{ "tables.actions" | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <!-- <button mat-icon-button matTooltip="{{'inputs.download_invoice' | translate}}" (click)="downloadInvoice(element.url_invoice)" *ngIf="(element.url_invoice)">
                    <mat-icon>download</mat-icon>
                  </button>
                  <button mat-icon-button disabled matTooltip="{{'inputs.download_invoice' | translate}}"  *ngIf="!(element.url_invoice)">
                    <mat-icon>download</mat-icon>
                  </button> -->
                  <button
                    mat-icon-button
                    *ngIf="element.status == 'failed'"
                    matTooltip="{{ element.error_message }}"
                    [matTooltipClass]="'my-tooltip'"
                    [matTooltipPosition]="'left'"
                  >
                    <mat-icon
                      style="{{ 'style.' + element.status | translate }}"
                      >{{ "icon." + element.status | translate }}
                    </mat-icon>
                  </button>

                  <button
                    mat-icon-button
                    *ngIf="
                      element.status == 'reserved' ||
                      element.status == 'paid' ||
                      element.status == 'lab'
                    "
                    matTooltip="{{ 'text.' + element.status | translate }}"
                    [matTooltipClass]="'my-tooltip'"
                    [matTooltipPosition]="'left'"
                    (click)="processProduct(element.id, element.status)"
                  >
                    <mat-icon
                      style="{{ 'style.' + element.status | translate }}"
                      >{{ "icon." + element.status | translate }}
                    </mat-icon>
                  </button>

                  <button
                    mat-icon-button
                    *ngIf="element.status == 'reviewed'"
                    matTooltip="{{ 'text.' + element.status | translate }}
                    {{ 'inputs.reviewed_by' | translate }}
                    {{ element.reviewed_name }}
                    {{ element.reviewing_date | date: 'd/M/Y, H:mm:ss' }}"
                    [matTooltipClass]="'my-tooltip'"
                    [matTooltipPosition]="'left'"
                    (click)="processProduct(element.id, element.status)"
                  >
                    <mat-icon
                      style="{{ 'style.' + element.status | translate }}"
                      >{{ "icon." + element.status | translate }}
                    </mat-icon>
                  </button>

                  <button
                    mat-icon-button
                    *ngIf="element.status == 'processed'"
                    matTooltip="{{ 'text.' + element.status | translate }}
                    {{ 'inputs.reviewed_by' | translate }}
                    {{ element.reviewed_name }}
                    {{ element.reviewing_date | date: 'd/M/Y, H:mm:ss' }}
                    {{ 'inputs.processed_by' | translate }}
                    {{ element.processor_name }}
                    {{ element.processing_date | date: 'd/M/Y, H:mm:ss' }}"
                    [matTooltipClass]="'my-tooltip'"
                    [matTooltipPosition]="'left'"
                    (click)="processProduct(element.id, element.status)"
                  >
                    <mat-icon
                      style="{{ 'style.' + element.status | translate }}"
                      >{{ "icon." + element.status | translate }}
                    </mat-icon>
                  </button>

                  <!--status: paid -> euro
                  confirmacion -> check_circle_outline-->
                </td>
              </ng-container>

              <ng-container matColumnDef="loading">
                <td mat-footer-cell *matFooterCellDef colspan="8">
                  <span>{{ "tables.loading" | translate }}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="no_data">
                <td mat-footer-cell *matFooterCellDef colspan="8">
                  <span>{{ "tables.no_data" | translate }}</span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              <tr
                mat-footer-row
                *matFooterRowDef="['loading']"
                [hidden]="!showOrderAdminProgressBar"
              ></tr>
              <tr
                mat-footer-row
                *matFooterRowDef="['no_data']"
                [hidden]="dataSource || showOrderAdminProgressBar "
              ></tr>
            </table>
            <mat-progress-bar
              *ngIf="showOrderAdminProgressBar"
              mode="indeterminate"
            ></mat-progress-bar>
            <mat-paginator
              [length]="totalItems"
              [pageSizeOptions]="[100, 50, 200]"
              [pageSize]="pageSize" [pageIndex]="pageIndex"
              (page)="pageEvent = $event; onPaginateChange($event)"
              showFirstLastButtons
            >
            </mat-paginator>
          </div>

          <!-- <mat-card *ngIf='!isList'> -->
          <div class="contenedor" *ngIf="!isList">
            <table mat-table [dataSource]="dataSource2" matSort class="detail">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ "tables.name" | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.photo_reportage_name }}
                </td>
              </ng-container>
              <!-- <ng-container matColumnDef="num_list">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'tables.num_list' | translate }} </th>
                  <td mat-cell *matCellDef="let element"> {{element.num_list}} </td>
                </ng-container> -->

              <ng-container matColumnDef="product_name_es">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  fxHide.lt-sm
                  style="display: {{ 'es' | translate }}"
                >
                  {{ "tables.product_name" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  fxHide.lt-sm
                  style="display: {{ 'es' | translate }}"
                >
                  {{ element.product_name_es }}
                </td>
              </ng-container>
              <ng-container matColumnDef="product_name_en">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  fxHide.lt-sm
                  style="display: {{ 'en' | translate }}"
                >
                  {{ "tables.product_name" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  fxHide.lt-sm
                  style="display: {{ 'en' | translate }}"
                >
                  {{ element.product_name_en }}
                </td>
              </ng-container>
              <ng-container matColumnDef="product_name_cat">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  fxHide.lt-sm
                  style="display: {{ 'cat' | translate }}"
                >
                  {{ "tables.product_name" | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  fxHide.lt-sm
                  style="display: {{ 'cat' | translate }}"
                >
                  {{ element.product_name_cat }}
                </td>
              </ng-container>

              <ng-container matColumnDef="album_id">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  fxHide.lt-sm
                >
                  <!-- {{ "tables.quantity" | translate }} -->
                  Album ID
                </th>
                <td mat-cell *matCellDef="let element" fxHide.lt-sm>
                  {{ element.album_id ? element.album_id : "n/a" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="quantity">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  fxHide.lt-sm
                >
                  {{ "tables.quantity" | translate }}
                </th>
                <td mat-cell *matCellDef="let element" fxHide.lt-sm>
                  {{ element.quantity }}
                </td>
              </ng-container>

              <ng-container matColumnDef="value">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  fxHide.lt-sm
                >
                  {{ "tables.value" | translate }}
                </th>
                <td mat-cell *matCellDef="let element" fxHide.lt-sm>
                  {{ element.value }} €
                </td>
              </ng-container>

              <ng-container matColumnDef="actions" class="actionsColumn">
                <th mat-header-cell *matHeaderCellDef>
                  {{ "tables.actions" | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <button
                    mat-icon-button
                    *ngIf="element.status == 'failed'"
                    matTooltip="{{ element.error_message }}"
                    [matTooltipClass]="'my-tooltip'"
                    [matTooltipPosition]="'left'"
                  >
                    <mat-icon
                      style="{{ 'style.' + element.status | translate }}"
                      >{{ "icon." + element.status | translate }}
                    </mat-icon>
                  </button>

                  <button
                    mat-icon-button
                    *ngIf="
                      element.status == 'reserved' ||
                      element.status == 'paid' ||
                      element.status == 'lab'
                    "
                    matTooltip="{{ 'text.' + element.status | translate }}"
                    [matTooltipClass]="'my-tooltip'"
                    [matTooltipPosition]="'left'"
                    style="float: right"
                    (click)="processProduct(element.id, element.status)"
                  >
                    <mat-icon
                      style="{{ 'style.' + element.status | translate }}"
                      >{{ "icon." + element.status | translate }}
                    </mat-icon>
                  </button>

                  <button
                    mat-icon-button
                    *ngIf="element.status == 'reviewed'"
                    matTooltip="{{ 'text.' + element.status | translate }}
                        {{ 'inputs.reviewed_by' | translate }}
                        {{ element.reviewed_name }}
                        {{ element.reviewing_date | date: 'd/M/Y, H:mm:ss' }}"
                    [matTooltipClass]="'my-tooltip'"
                    [matTooltipPosition]="'left'"
                    style="float: right"
                    (click)="processProduct(element.id, element.status)"
                  >
                    <mat-icon
                      style="{{ 'style.' + element.status | translate }}"
                      >{{ "icon." + element.status | translate }}
                    </mat-icon>
                  </button>

                  <button
                    mat-icon-button
                    *ngIf="element.status == 'processed'"
                    matTooltip="{{ 'text.' + element.status | translate }}
                        {{ 'inputs.reviewed_by' | translate }}
                        {{ element.reviewed_name }}
                        {{ element.reviewing_date | date: 'd/M/Y, H:mm:ss' }}
                        {{ 'inputs.processed_by' | translate }}
                        {{ element.processor_name }}
                        {{ element.processing_date | date: 'd/M/Y, H:mm:ss' }}"
                    [matTooltipClass]="'my-tooltip'"
                    [matTooltipPosition]="'left'"
                    style="float: right"
                    (click)="processProduct(element.id, element.status)"
                  >
                    <mat-icon
                      style="{{ 'style.' + element.status | translate }}"
                      >{{ "icon." + element.status | translate }}
                    </mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns2"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                  <span *ngIf="showOrderAdminProgressBar2">{{
                    "tables.loading" | translate
                  }}</span>
                  <span *ngIf="!showOrderAdminProgressBar2">{{
                    "tables.no_data_found" | translate
                  }}</span>
                </td>
              </tr>
            </table>
            <mat-progress-bar
              *ngIf="showOrderAdminProgressBar2"
              mode="indeterminate"
            ></mat-progress-bar>
            <mat-paginator
              [pageSizeOptions]="[100, 10, 20, 50]"
              showFirstLastButtons
            ></mat-paginator>
          </div>
          <!-- </mat-card> -->
        </div>
      </div>
    </div>
  </div>

  <div style="float: left">
    <mat-icon style="{{ 'style.paid' | translate }}"
      >{{ "icon.paid" | translate }}
    </mat-icon>
    {{ "status.paid" | translate }}
    <mat-icon style="{{ 'style.reserved' | translate }}"
      >{{ "icon.reserved" | translate }}
    </mat-icon>
    {{ "status.reserved" | translate }}
    <mat-icon style="{{ 'style.lab' | translate }}"
      >{{ "icon.lab" | translate }}
    </mat-icon>
    {{ "status.lab" | translate }}
    <mat-icon style="{{ 'style.reviewed' | translate }}"
      >{{ "icon.reviewed" | translate }}
    </mat-icon>
    {{ "status.reviewed" | translate }}
    <mat-icon style="{{ 'style.processed' | translate }}"
      >{{ "icon.processed" | translate }}
    </mat-icon>
    {{ "status.processed" | translate }}
  </div>
  <div style="clear: left"></div>
</div>
